import { safeSessionStorage } from "../safeStorage";
import { isAutomatedSession } from "./isAutomated";

export * from "./ecommerce";
export * from "./isAutomated";
export * from "./useEcommerce";

const METRIC_ID = 20518312;

export const GOALS = {
  addToCart: "addToCart",
  backCallOpen: "backCallOpen",
  backCallSent: "backCallSent",
  buyOneClickOpen: "buyOneClickOpen",
  buyOneClickSent: "buyOneClickSent",
  confirm: "confirm",
  feedBackOpen: "feedBackOpen",
  feedBackSent: "feedBackSent",
  findLowPriceOpen: "findLowPriceOpen",
  findLowPriceSent: "findLowPriceSent",
  mobileBottomSocClick: "mobileBottomSocClick",
  orderInstallOpen: "orderInstallOpen",
  orderInstallSent: "orderInstallSent",
  serviceOrderOpen: "serviceOrderOpen",
  serviceOrderSent: "serviceOrderSent",
  serviceQuestionOpen: "serviceQuestionOpen",
  serviceQuestionSent: "serviceQuestionSent",
  productQuestionOpen: "productQuestionOpen",
  productQuestionSent: "productQuestionSent",
  similarProductOpen: "similarProductOpen",
  similarProductSent: "similarProductSent",
  subscribeProductOpen: "subscribeProductOpen",
  subscribeProductSent: "subscribeProductSent",
  orderWithElectricOpen: "orderWithElectricOpen",
  orderWithElectricSent: "orderWithElectricSent",
  triggerFivePageOpen: "triggerFivePageOpen",
  triggerFivePageSent: "triggerFivePageSent",
  triggerTryExitOpen: "triggerTryExitOpen",
  triggerTryExitSent: "triggerTryExitSent",
  triggerThreeMinsOpen: "triggerThreeMinsOpen",
  triggerThreeMinsSent: "triggerThreeMinsSent",
} as const;
type GoalsType = keyof typeof GOALS;

export const reachGoal = (goal: GoalsType | CartGoalsType, user?: any) => {
  // Сотрудники и e2e-прогоны статистику не портят.
  if (user?.IS_MANAGER || user?.IS_ADMIN || isAutomatedSession()) {
    return;
  }
  try {
    // @ts-ignore
    if (typeof ym !== "undefined") {
      // @ts-ignore
      ym(METRIC_ID, "reachGoal", goal);
    }
  } catch (e) {
    console.log("reachGoal error", e);
  }
};

/** Параметры визита — те же отсечки, что у `reachGoal`. */
export const sendVisitParams = (params: Record<string, any>, user?: any) => {
  if (user?.IS_MANAGER || user?.IS_ADMIN || isAutomatedSession()) {
    return;
  }
  try {
    // @ts-ignore
    if (typeof ym !== "undefined") {
      // @ts-ignore
      ym(METRIC_ID, "params", params);
    }
  } catch (e) {
    console.log("sendVisitParams error", e);
  }
};

export const CART_GOALS = {
  addToCart: "addToCart",
  openCart: "openCart",
  cartStep1: "cartStep1",
  cartStep2: "cartStep2",
  cartStep3: "cartStep3",
  cartSuccess: "cartSuccess",
} as const;

type CartGoalsType = keyof typeof CART_GOALS;

export const reachCartGoal = (goal: CartGoalsType, user?: any) => {
  if (user?.IS_MANAGER || user?.IS_ADMIN) {
    return;
  }
  try {
    let existedSessionGoals = getExistedGoalsFromSession();
    if (
      goal === CART_GOALS.addToCart &&
      existedSessionGoals.includes(CART_GOALS.cartSuccess)
    ) {
      existedSessionGoals = [];
    }
    if (!existedSessionGoals.includes(goal)) {
      pushGoalsToSession([...existedSessionGoals, goal]);
      reachGoal(goal);
    }
  } catch (e) {
    console.log("reachCartGoal error", e);
  }
};

function getExistedGoalsFromSession(): CartGoalsType[] {
  const existedSessionGoalsString = safeSessionStorage.getItem(
    "existedSessionGoals",
  );
  if (existedSessionGoalsString) {
    return existedSessionGoalsString.split(",") as CartGoalsType[];
  }
  return [];
}

function pushGoalsToSession(goals: CartGoalsType[]) {
  safeSessionStorage.setItem("existedSessionGoals", goals.join(","));
}
